module.exports = __webpack_public_path__ + "media/images/Twitter_Social_Icon_Circle_Color-01671aab.png";